export const AUTH_ENTRY_PATHS = ["/", "/splash", "/login", "/login/email", "/signup"] as const;

export const AUTH_PUBLIC_PATHS = [
  ...AUTH_ENTRY_PATHS,
  "/verify-email",
  "/signup/property",
  "/forgot-password",
  "/forgot-password/sent",
  "/forgot-password/reset",
  "/landing",
  "/design-system",
  "/app-chooser",
] as const;

export function isAuthEntryPath(pathname: string): boolean {
  return (AUTH_ENTRY_PATHS as readonly string[]).includes(pathname);
}
